exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#StatsDisplay{background:#607d8b;overflow:scroll;padding:30px}#StatsDisplay pre{margin-bottom:40px}div#buffered_log{margin-bottom:60px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-088dad84!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Debug/DebugStats.vue
// module id = 47
// module chunks = 0